import { render, staticRenderFns } from "./TasklistTable.vue?vue&type=template&id=bf4735ee"
import script from "./TasklistTable.vue?vue&type=script&lang=js"
export * from "./TasklistTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports